const Cvv = Object.freeze({
  NAME: 'start',
  PAGE_SUBFUNCTION: 'cvv verify',
  MESSAGE_KEY: 'default'
})

export default Cvv
